import { render } from "./OLookupMember.vue?vue&type=template&id=38fec6d4&scoped=true"
import script from "./OLookupMember.vue?vue&type=script&lang=js"
export * from "./OLookupMember.vue?vue&type=script&lang=js"

import "./OLookupMember.vue?vue&type=style&index=0&id=38fec6d4&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fec6d4"]])

export default __exports__